import { render } from "./BasicTextArea.vue?vue&type=template&id=2798a496&scoped=true"
import script from "./BasicTextArea.vue?vue&type=script&lang=js"
export * from "./BasicTextArea.vue?vue&type=script&lang=js"

import "./BasicTextArea.vue?vue&type=style&index=0&id=2798a496&scoped=scoped&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2798a496"]])

export default __exports__